export const iconFontAwesomeHolidaysCookieBite = (
	<i className="fa-solid fa-cookie-bite"></i>
);
